import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

import { MdTrendingDown } from 'react-icons/md'

import 'react-toastify/dist/ReactToastify.css'

import { saveAllData } from '../../lib/save-data'

import Sidebar from './../../components/sidebar'
import PageTitle from './../../components/pageTitle'
import TotalDRE from '../../components/total/dre'
import Footer from './../../components/footer'
import SubTotalToogle from './../../components/subtotal'
import ItemCurrency from './../../components/item-currency'

import * as SidebarActions from '../../redux/store/actions/sidebar'
import * as DREActions from '../../redux/store/actions/dre'

class DRE extends Component {
  constructor (props) {
    super(props)
    this.props.clickSidebar(4)
    this.sumTotal()
  }

  async clickSave () {
    Swal.fire({
      title: 'Salvar Informações',
      text: 'Deseja salvar as informações inseridas ?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#525ad0',
      cancelButtonColor: '#272c84'
    }).then(async result => {
      if (!result.dismiss) {
        await saveAllData(this.props).then(res => {
          toast('Informações salvas no servidor', {
            className: 'toast-background',
            bodyClassName: 'toast-body',
            progressClassName: 'toast-progress',
            position: 'top-right',
            hideProgressBar: true,
            style: {
              borderRadius: '10px'
            }
          })
        })
        // this.props.history.push('/dre/' + this.props.match.params.cnpj);
      }
    })
  }

  async sumTotal () {
    await this.props.sumSubTotal(this.props.dados.datas)
  }

  render () {
    const { dre, sidebar } = this.props

    return (
      <div className='container-fluid min-vh-100' style={{ padding: '0' }}>
        <div className='row min-vh-100 no-gutters'>
          <Sidebar />
          <div className='content col-auto'>
            <PageTitle
              title='DRE - Demonstração do Resultado do Exercício'
              icon={MdTrendingDown}
              btnSalvar={this.clickSave.bind(this)}
              redux_data={dre}
            />
            <div className='bodyContent' style={{ paddingTop: '3em' }}>
              <ItemCurrency
                item={dre.items.receita_liquida}
                keyName='receita_liquida'
                name='Receita Líquida'
                type='dre'
                redux_data={dre}
                redux_command='receita_liquida'
                hide_chart={!this.props.sidebar.showChart}
              />
              <div
                className={sidebar.showSubtotal ? 'divisor' : 'divisor-mini'}
              />

              <ItemCurrency
                item={dre.items.lucro_bruto}
                keyName='lucro_bruto'
                name='Lucro Bruto'
                type='dre'
                redux_data={dre}
                redux_command='lucro_bruto'
                hide_chart={!this.props.sidebar.showChart}
              />
              <div
                className={sidebar.showSubtotal ? 'divisor' : 'divisor-mini'}
              />

              <ItemCurrency
                item={dre.items.lucro_operacional}
                keyName='lucro_operacional'
                name='Lucro Operacional'
                type='dre'
                redux_data={dre}
                redux_command='lucro_operacional'
                hide_chart={!this.props.sidebar.showChart}
              />
              <div
                className={sidebar.showSubtotal ? 'divisor' : 'divisor-mini'}
              />

              <ItemCurrency
                item={dre.items.lucro_operacional_liquido}
                keyName='lucro_operacional_liquido'
                name='Lucro Operacional Líquido'
                type='dre'
                redux_data={dre}
                redux_command='lucro_operacional_liquido'
                hide_chart={!this.props.sidebar.showChart}
              />
              <div
                className={sidebar.showSubtotal ? 'divisor' : 'divisor-mini'}
              />

              <ItemCurrency
                item={dre.items.lucro_liquido}
                keyName='lucro_liquido'
                name='Lucro Líquido'
                type='dre'
                redux_data={dre}
                hide_total
                hide_chart={!this.props.sidebar.showChart}
              />
            </div>
            <SubTotalToogle />
            <TotalDRE />

            <Footer />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dados: state.dados,
  ativo: state.ativo,
  passivo: state.passivo,
  dre: state.dre,
  mutacao: state.mutacao,
  fundos: state.fundos,
  parceiros: state.parceiros,
  rating: state.rating,

  sidebar: state.sidebar,
  isGroup: state.sidebar.isGroup
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  clickSidebar: item => dispatch(SidebarActions.clickSidebar(item)),
  sumSubTotal: dados => dispatch(DREActions.sumSubTotal(dados))
})

export default connect(mapStateToProps, mapDispatchToProps)(DRE)
